import { z } from 'zod';

export const clientProjectInputSchema = z.object({
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  sigla: z
    .string()
    .trim()
    .min(1, 'Obrigatório')
    .max(10, 'Máximo 10 caracteres')
    .transform((s) => s.toUpperCase()),
  ativo: z.boolean().optional(),
});

export type ClientProjectFormValues = z.input<typeof clientProjectInputSchema>;
